import { useStore } from "react-admin";

export const enforceGroupId = () => {
	const [ activeGroupId ] = useStore('activeGroupId', null);
	return { group_id: activeGroupId };
}

export const formatFileSize = (bytes) => {
	if (!bytes) return '';
	const kb = bytes / 1024;
	const mb = kb / 1024;
	return mb > 1 ? `${mb.toFixed(1)} MB` : `${kb.toFixed(0)} KB`;
};
